import { render, staticRenderFns } from "./KinvaDocDelete.vue?vue&type=template&id=66869238"
import script from "./KinvaDocDelete.vue?vue&type=script&lang=js"
export * from "./KinvaDocDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports